import Vue from 'vue';

export default Vue.extend({
  name: 'verifyMixin',

  methods: {
    $_verifySearch (formObs, verify, data, url) {
      this.$refs[formObs].validate().then((success) => {
        console.log('success', success);
        if (success) {
          if (verify === this.identifyCode) {
            console.log('query API');
            this.axiosServiceSend(data, url, 'post', 'Query');
          } else {
            this.showApiMessage('info', '驗證碼錯誤，請重新輸入', '訊息');
          }
        } else if (verify !== this.identifyCode && verify !== '') {
          this.showApiMessage('info', '驗證碼錯誤，請重新輸入', '訊息');
        }
      });
    }
  },
});
